import React, { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";
import "./offer-viewport-summary.css";

const OfferViewportSummaryContext = createContext({
  enabled: false,
  slotEl: null,
});

/**
 * Docks Kalkyle / Tilbudslinjer totals to the bottom of the offer editor
 * (viewport under dashboard chrome), not the inner card/column.
 */
export function OfferViewportSummaryProvider({ enabled = false, children }) {
  const [slotEl, setSlotEl] = useState(null);

  return (
    <OfferViewportSummaryContext.Provider
      value={{ enabled: Boolean(enabled), slotEl }}
    >
      {children}
      {enabled ? (
        <div
          ref={setSlotEl}
          className="offer-viewport-summary"
        />
      ) : null}
    </OfferViewportSummaryContext.Provider>
  );
}

export function OfferViewportSummary({ children }) {
  const { enabled, slotEl } = useContext(OfferViewportSummaryContext);
  if (!enabled) return children;
  if (!slotEl) return null;
  return createPortal(children, slotEl);
}
